import { CLIENT_TYPE_PROPOSER } from '@/constants';
import { store } from '@/store';
import { PlanSummaryState } from '@/types/PlanSummary';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptorInstance from './axiosInterceptorInstance';
import { DocumentsRequest } from '@/types/Document';

export const documents = createAsyncThunk(
  'documents',
  async ({
    language,
    documentType,
  }: {
    language: string;
    documentType: string;
  }) => {
    try {
      const rootState = store.getState();
      const planSummary = rootState.planSummary;
      const request: DocumentsRequest = {
        appId: planSummary.appId,
        refId: planSummary.referenceId,
        email: getApplicantEmail(planSummary),
        documentType,
        Language: language,
      };
      const relativeUrl = 'documents/';
      const apiUrl = `/quote/?relativeUrl=${relativeUrl}`;
      // const response = await axiosInterceptorInstance.post(apiUrl, request, {responseType: 'json', headers: {
      //   'Content-Type': 'application/json', // Adjust content type as needed
      // },});
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

function getApplicantEmail(planSummary: PlanSummaryState) {
  const proposer = planSummary.applicants
    .find((applicant) => applicant.clientType === CLIENT_TYPE_PROPOSER)
    ?.emails.at(0)?.value;
  if (proposer) {
    return proposer;
  } else return '';
}
